import { useProduct } from "contexts/ProductContext";
import { useTranslation } from "react-i18next";
import { useFeatureFlags } from "contexts/FeatureFlagContext";
import { InfoTooltip } from "components/InfoTooltip";
import { DatabaseCodes } from "./components/DatabaseCodes";
import { FinalThemaList } from "./components/FinalList/FinalThemaList";
import { GeneratedCodes } from "./components/GeneratedCode";

export const ThemaTab = () => {
  const { product } = useProduct();
  const { t } = useTranslation(["productDetails"]);
  const { features } = useFeatureFlags();

  if (!product) {
    return;
  }

  const themaVersion = features.operationalThemaVersion;

  return (
    <div className="flex flex-row gap-4 h-full">
      <div className="flex-1 flex min-h-40">
        <div className="flex flex-col flex-1 gap-2">
          <div className="flex gap-4 flex-1 min-h-0">
            <DatabaseCodes />
            <GeneratedCodes />
          </div>
          <div className="flex flex-row items-center gap-2 bg-secondary-50 p-2 rounded-xl">
            <InfoTooltip
              text={t("thema.version", { version: themaVersion })}
              triggerClassName="opacity-100! text-secondary-400 ml-auto mr-2"
              side="top"
            />
          </div>
        </div>
      </div>

      <div className="max-w-90 min-h-36">
        <FinalThemaList />
      </div>
    </div>
  );
};
